module.exports = __webpack_public_path__ + "static/media/ROU.2c8b4870.svg";